// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"097dd9be","798":"ffc8ec03"}[chunkId] + ".chunk.js";
};